import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../../../utils/api';

// Configure axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

// Add auth header interceptor
api.interceptors.request.use(async (config) => {
  const headers = await getAuthHeader(config.method);
  config.headers = { ...config.headers, ...Object.fromEntries(headers.entries()) };
  return config;
});

const fetchExchangeRate = async (fromCurrency, toCurrency) => {
  if (!fromCurrency || !toCurrency || fromCurrency === toCurrency) {
    return null;
  }

  const { data } = await api.get(`/exchange-rates/pair/${fromCurrency}/${toCurrency}`);
  
  if (data.result !== "success") {
    throw new Error('Invalid response from exchange rate API');
  }
  return data.conversion_rate;
};

export function useExchangeRate(fromCurrency, toCurrency) {
  return useQuery({
    queryKey: ['exchangeRate', fromCurrency, toCurrency],
    queryFn: () => fetchExchangeRate(fromCurrency, toCurrency),
    enabled: Boolean(fromCurrency && toCurrency && fromCurrency !== toCurrency),
    staleTime: 5 * 60 * 1000, // Consider rates stale after 5 minutes
    gcTime: 10 * 60 * 1000, // Keep rates in cache for 10 minutes (renamed from cacheTime in v5)
  });
}
